import intermind, { CalendarEvent } from 'intermind';

export class CalendarService {
  async getGoogleCalendarAuthUrl(): Promise<string> {
    return await intermind.calendar.google.authUrl();
  }

  async handleGoogleCalendarAuthCallback(code: string): Promise<void> {
    await intermind.calendar.google.authCallback(code);
    await intermind.calendar.google.sync();
  }

  async listEvents(): Promise<CalendarEvent[]> {
    return await intermind.calendar.events();
  }

  async listUpcomingEvents(): Promise<CalendarEvent[]> {
    return await intermind.calendar.upcomingEvents();
  }
}

export const calendarService = new CalendarService();
